import React from "react";

export default function Diagnostics() {
  return <div>Diagnostics</div>;
}
